/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { IColumn } from 'types'
import MainTableActionButtons from 'components/organisms/MainTableActionButtons'

export const useHighlightsTableModel = () => {
  const { t } = useTranslation()

  const handleDomainFormat = useCallback(
    (cellValue: string, row: any, index: number) => row.domain?.title ?? '',
    [],
  )
  const handleActionsFormat = useCallback(
    (cellValue: string, row: any, index: number) => <MainTableActionButtons row={row} overridePermissions={true} />,
    [],
  )

  const columns: IColumn[] = [
    {
      title: `${t('common.domain')}`,
      field: 'domain',
      order: true,
      width: '20%',
      format: handleDomainFormat,
    },
    {
      title: `${t('common.title')}`,
      field: 'title',
      order: true,
      width: '65%',
    },
    {
      title: '',
      field: '',
      width: '15%',
      align: 'end',
      order: false,
      format: handleActionsFormat,
    },
  ]

  return columns
}